import React from 'react';
import './Hero.css';
import productivite from '../../../img/Icone_productivite.svg';
import efficacite from '../../../img/Icone_efficacite.svg';
import uniformisee from '../../../img/Icone_contrat.svg';
import optimiser from '../../../img/Icone_optimisee.svg';

const Hero = () => {
  return (
    <section id="hero" className="hero">
    <div className="hero-background">
      <div className="hero-content">
        <h3>Editez vos documents administratifs en quelques clics</h3>
        <p className="hero-description">
          VéhiDoc est une interface de solution développée pour répondre efficacement aux
          besoins des professionnels de véhicules (automobiles, motos, poids lourds, tracteurs...)
          pour exercer l&apos;activité neuf et d&apos;occasion en toute simplicité. Créez et éditez vos
          documents officiels en toute simplicité.
        </p>
      </div>
    </div>

      <div className="hero-fonctionnalities">
        <div className="hero-fonctionnalities-item item-1">
          <h3>PRODUCTIVITÉ</h3>
          <div className="content-wrapper">
            <p><span className="hero-description-span">Gain de temps</span> en éditant facilement tous vos documents administratifs.</p>
            <img 
              src={productivite} 
              alt="Icône productivité" 
            />
          </div>
        </div>

        <div className="hero-fonctionnalities-item item-2">
          <h3>EFFICACITÉ</h3>
          <div className="content-wrapper">
            <p><span className="hero-description-span">Éditez</span> vos documents en quelques clics, pour un gain de temps et un <span className="hero-description-span">chiffre d&apos;affaires </span> supplémentaire.</p>
            <img 
              src={efficacite} 
              alt="Icône efficacité" 
            />
          </div>
        </div>

        <div className="hero-fonctionnalities-item item-3">
          <h3>UNIFORMISER</h3>
          <div className="content-wrapper">
            <p>Accèdez à des documents uniformisés, personnalisés et sans erreur.</p>
            <img 
              src={uniformisee} 
              alt="Icône uniformisation" 
            />
          </div>
        </div>

        <div className="hero-fonctionnalities-item item-4">
          <h3>OPTIMISER</h3>
          <div className="content-wrapper">
          <p>Tous vos dossiers administratifs multi-sites</p>
          <img 
            src={optimiser} 
            alt="Icône optimisation" 
          />
          </div>
        </div>
      </div>
      <div className="hero-description2">
        <p>De l&apos;achat à la vente d&apos;un véhicule, de nombreux documents administratifs vous sont nécessaires.
        VéhiDoc vous aide à rendre ces <span className="highlight">démarches faciles, fiables et rapides.</span></p>
        <p className="hero-description-p">Déclaration achat, cession de véhicule, bon de préparation, attestation de
        dépôt, confirmation de commande, déclaration de vente, certificat
        d&apos;immatriculation, mandat..</p>
        <p>VéhiDoc s&apos;adapte à chaque structure en fonction de vos spécificités, <span className="hero-description-span">vous accompagne </span>et <span className="hero-description-span">vous forme</span>.<br/>
        Son but ? Votre satisfaction client.</p>
      </div>
    </section>
  );
};

export default Hero;